//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "LayoutFooter"
};